import { savedOrderListTableStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListTable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

savedOrderListTableStyles.orderDateHeader = {
    css: css`
        > button {
            justify-content: center;
        }
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    span[class^="TypographyStyle"] {
                        font-size: 12px;
                    }
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};
savedOrderListTableStyles.shipToLabelCell = {
    css: css`
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
        }
    `,
};
savedOrderListTableStyles.subtotalCell = {
    alignX: "right",
    css: css`
     text-align: right !important;
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
           
        }
    `,
};

savedOrderListTableStyles.shipToLabelHeader = {
    css: css`
        > button {
            justify-content: center;
        }
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    span[class^="TypographyStyle"] {
                        font-size: 12px;
                        white-space: nowrap;
                    }
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};
savedOrderListTableStyles.subtotalHeader = {
    css: css`
        > button {
            justify-content: center;
        }
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    span[class^="TypographyStyle"] {
                        font-size: 12px;
                        white-space: nowrap;
                    }
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};
savedOrderListTableStyles.orderDateCell = {
    css: css`
        span[class^="TypographyStyle"] {
            color: ${getColor("text.link")};
            &:hover {
                text-align: center;
                text-decoration-line: underline;
            }
        }
    `,
};

savedOrderListTableStyles.dataTableRow = {
    css: css`
        &:nth-child(even) {
            background: ${getColor("common.background")} !important;
        }
    `,
};
